module.exports = __webpack_public_path__ + "img/btn_close_white.7be246d4.svg";